module.exports = __webpack_public_path__ + "resources/icon-new.64ec6bccbc7c122a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/new-game-hot/img/icon-new.png
// module id = 917
// module chunks = 0